import { trackContact } from '@/utils/fbPixel';

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.link/rb4jxv"
      target="_blank"
      rel="nofollow noreferrer"
      onClick={trackContact}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 flex items-center justify-center bg-[#25D366] hover:bg-green-500 rounded-full shadow-2xl shadow-green-900/40 transition-all duration-200 hover:scale-110 cursor-pointer"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-white text-3xl"></i>
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#E10600] rounded-full animate-ping"></span>
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#E10600] rounded-full"></span>
    </a>
  );
}
